import { StatusEnum, statusLabels } from "../../../shared";

export const generateCombinations = (
  variantAttributes,
  productName,
  stockKeepingUnitPrefix
) => {
  const combinations = [];

  if (variantAttributes.length === 1) {
    // Handle the case where there is exactly one variant attribute
    variantAttributes[0].values.forEach((value) => {
      let sku = stockKeepingUnitPrefix;
      const combination = {
        status: statusLabels[StatusEnum.INACTIVE],
        SKU: "",
        name: "",
      };

      combination[variantAttributes[0].attribute.name] = value;
      sku += `/${value}`;
      combination.SKU = sku;
      combination.name = `${productName} ${value}`;
      combinations.push(combination);
    });
  } else {
    const generateCartesianCombinations = (arrays) => {
      return arrays.reduce((a, b) =>
        a.flatMap((d) => b.map((e) => [d, e].flat()))
      );
    };

    const attributeValues = variantAttributes.map((attr) => attr.values);

    const cartesianCombinations =
      generateCartesianCombinations(attributeValues);

    cartesianCombinations.forEach((values) => {
      let sku = stockKeepingUnitPrefix;
      const combination = {
        status: statusLabels[StatusEnum.INACTIVE],
        SKU: "",
        name: "",
      };

      const nameParts = values.map((value, index) => {
        combination[variantAttributes[index].attribute.name] = value;
        sku += `/${value}`;
        return value;
      });

      combination.SKU = sku;
      combination.name = `${productName} ${nameParts.join("/")}`;
      combinations.push(combination);
    });
  }

  return combinations;
};
